import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle-btn"
      aria-label={`Switch to ${isDark ? "light" : "dark"} theme`}
      className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-bold text-slate-700 shadow-sm transition-colors duration-200 hover:border-blue-300 dark:border-white/15 dark:bg-white/5 dark:text-slate-200 dark:hover:border-white/30"
    >
      {isDark ? (
        <>
          <Moon size={14} className="text-blue-400" />
          <span data-testid="theme-toggle-label">Dark</span>
        </>
      ) : (
        <>
          <Sun size={14} className="text-amber-500" />
          <span data-testid="theme-toggle-label">Light</span>
        </>
      )}
      <span
        className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors duration-200 ${
          isDark ? "bg-blue-600" : "bg-slate-300"
        }`}
      >
        <span
          className={`inline-block h-3 w-3 rounded-full bg-white shadow transition-transform duration-200 ${
            isDark ? "translate-x-3.5" : "translate-x-0.5"
          }`}
        />
      </span>
    </button>
  );
};
